import { apiClient, type PartnerUserExEntity } from '@/libs/api'

export type FetchPartnerUserQuery = {
  tenantKey: string
  userId: number
}

export const fetchPartnerUser = async (
  { tenantKey, userId }: FetchPartnerUserQuery,
  signal?: AbortSignal
): Promise<PartnerUserExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .partner_users._id(userId)
    .$get({ config: { signal } })
  return data
}
